import { render, staticRenderFns } from "./senderSelector.vue?vue&type=template&id=6dc2a506&scoped=true"
import script from "./senderSelector.vue?vue&type=script&lang=js"
export * from "./senderSelector.vue?vue&type=script&lang=js"
import style0 from "./senderSelector.vue?vue&type=style&index=0&id=6dc2a506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc2a506",
  null
  
)

export default component.exports